import { GzFontSizeChangerWebComponent } from './component/GzFontSizeChangerWebComponent';

export { GzFontSizeChangerWebComponent };
